const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const isPortrait = (img) => {
  var w = img.naturalWidth || img.width,
    h = img.naturalHeight || img.height;
  return h > w;
};

const getOuterWidth = (el) => {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);

  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};
const getOuterHeight = (el) => {
  var width = el.offsetHeight;
  var style = getComputedStyle(el);

  width += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return width;
};

const getOffsetTop = (elem) => {
  // Set our distance placeholder
  var distance = 0;

  // Loop up the DOM
  if (elem.offsetParent) {
    do {
      distance += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }

  // Return our distance
  return distance < 0 ? 0 : distance;
};

var getClosest = function (elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
};

function throttle(fn, wait) {
  var time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
}

function isScrolledIntoView(elem, partial = true) {
  var rect = elem.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  console.log('>> animation.js:18', { rect, elemTop, elemBottom });

  // Only completely visible elements return true:
  //   var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
  // Partially visible elements return true:
  //var isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return partial ? elemTop < window.innerHeight && elemBottom >= 0 : elemTop >= 0 && elemBottom <= window.innerHeight;
}

export { debounce, getOffsetTop, getOuterWidth, getOuterHeight, getClosest, isPortrait, throttle, isScrolledIntoView };
